export default __webpack_public_path__ + "static/caroline-33ef0d5cbc4a80da2318d8650b8ae52c.jpg";